import { useState, useEffect } from "react";

import { useWebuildAPIClient } from "@/providers/WeBuildClientProvider";
import { logger } from "@/telemetry";

interface ModelOption {
  id: string;
  name: string;
}

let cachedModels: ModelOption[] | null = null;

/**
 * Shared hook for fetching the list of available models.
 * Caches the result so switching between agent and team panels
 * does not fire duplicate API calls.
 */
export const useAvailableModels = () => {
  const { platformClient } = useWebuildAPIClient();
  const [models, setModels] = useState<ModelOption[]>(cachedModels || []);

  useEffect(() => {
    if (cachedModels) {
      setModels(cachedModels);

      return;
    }

    const fetchModels = async () => {
      if (!platformClient) return;
      try {
        const result = await platformClient.models.list();
        const mapped = result.map((m: any) => ({ id: m.id || m.name, name: m.name || m.id }));

        cachedModels = mapped;
        setModels(mapped);
      } catch (error) {
        logger.error("Failed to fetch models", error);
      }
    };

    fetchModels();
  }, [platformClient]);

  return models;
};
